module.exports = __webpack_public_path__ + "static/glasengel_1.d46304e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fulls/glasengel_1.jpg
// module id = 548
// module chunks = 35783957827783